/**
 * Returns "smooth" or "auto" based on the user's
 * `prefers-reduced-motion` system setting.
 */
export const getPreferredScrollBehavior = (): ScrollBehavior => {
  if (typeof window === "undefined" || !window.matchMedia) return "smooth";
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ? "auto"
    : "smooth";
};

/** Scroll an element into view, honoring prefers-reduced-motion. */
export const scrollIntoViewRespectingMotion = (
  el: Element,
  options: Omit<ScrollIntoViewOptions, "behavior"> = {},
) => {
  el.scrollIntoView({ behavior: getPreferredScrollBehavior(), ...options });
};

/** Scroll the window, honoring prefers-reduced-motion. */
export const scrollToRespectingMotion = (
  options: Omit<ScrollToOptions, "behavior"> = {},
) => {
  window.scrollTo({ behavior: getPreferredScrollBehavior(), ...options });
};
